/**
 * 微信浏览器 UA 检测与微信 H5 自动登录抑制。
 *
 * isWechatBrowser 用于判断用户是否在微信内置浏览器中打开页面。
 * 排除企业微信（wxwork），企业微信走自己的 OAuth 流程。
 *
 * 参考: ai-workbench (Javis) login-priority.ts isWechatBrowser()
 */
export function isWechatBrowser(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent.toLowerCase();
  return ua.includes('micromessenger') && !ua.includes('wxwork');
}

// sessionStorage key：标记用户刚刚主动登出，抑制微信 H5 的自动登录。
// 背景：LoginPage 在微信内置浏览器中未登录时会自动跳转 wechat_h5 OAuth，
// 但用户主动登出后，微信侧仍保留公众号授权，会静默重新登录，导致"退出后又自动登录"的死循环。
// logout 时 set 该标记，LoginPage 自动跳转据此跳过；用户主动点微信登录按钮时清除。
const WECHAT_AUTO_LOGIN_SUPPRESS_KEY = 'knox_wechat_auto_login_suppressed';

/** 标记当前会话需抑制微信 H5 自动登录（在 logout 时调用）。 */
export function markWechatAutoLoginSuppressed(): void {
  try {
    sessionStorage.setItem(WECHAT_AUTO_LOGIN_SUPPRESS_KEY, '1');
  } catch {
    // sessionStorage 不可用时静默忽略（隐私模式等），自动登录仍可用。
  }
}

/** 是否应抑制微信 H5 自动登录（LoginPage 自动跳转 effect 据此跳过）。 */
export function isWechatAutoLoginSuppressed(): boolean {
  try {
    return sessionStorage.getItem(WECHAT_AUTO_LOGIN_SUPPRESS_KEY) === '1';
  } catch {
    return false;
  }
}

/** 清除抑制标记（用户主动点微信登录按钮时调用，恢复正常自动登录语义）。 */
export function clearWechatAutoLoginSuppressed(): void {
  try {
    sessionStorage.removeItem(WECHAT_AUTO_LOGIN_SUPPRESS_KEY);
  } catch {
    // no-op
  }
}
